<template>
  <hgroup class="header">
    <h1>Passt zu jedem Anlass</h1>
    <h2>Adjektive auswählen</h2>
  </hgroup>
  <div class="body">
    <div class="step">
      <div class="options indicator">
        <button v-for="option in options[currentIndex].items" :key="option.wert" @click="select($event)"
          :value="option.wert" :class="[option.class, (isSelected(currentIndex, option.wert) ? 'selected' : '')]">{{
            option.name }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FinderStep3',
  computed: {
    currentIndex: {
      get() {
        return this.$store.state.currentIndex
      },
      set(value) {
        this.$store.commit('setCurrentIndex', { currentIndex: value })
      }
    },
    options: {
      get() {
        return this.$store.state.options
      }
    },
    selectedOptions: {
      get() {
        return this.$store.state.selectedOptions
      },
      set(value) {
        this.$store.commit('setSelectedOptions', { selectedOptions: value })
      }
    },
    showNext: {
      get() {
        return this.$store.state.showNext
      },
      set(value) {
        this.$store.commit('setShowNext', { showNext: value })
      }
    }
  },
  methods: {
    select(event) {
      let el = event.target
      let step = this.currentIndex

      if (step in this.selectedOptions === false) {
        this.selectedOptions[step] = []
      }
      // Is value set
      if (!this.selectedOptions[step].includes(el.value)) {
        // Reset former step values if not multiple
        if (!this.options[step].multiple) { 
          this.selectedOptions[step] = []
        }
        // Set new value
        this.selectedOptions[step].push(el.value)
      } else { // Unset value
        let key = this.selectedOptions[step].findIndex(element => element === el.value)
        this.selectedOptions[step].splice(key, 1)
      }

      // el.classList.toggle('selected');
      this.$forceUpdate()

      if (this.selectedOptions[step] !== undefined && this.selectedOptions[step].length) {
        this.showNext = true
      } else {
        this.showNext = false
      }

      if (!this.options[step].multiple) {
        // this.next()
      }
    },
    isSelected(step, value) {
      if (step in this.selectedOptions && this.selectedOptions[step].includes(value)) {
        console.log(value + ' is selected in step ' + step)
        return true
      }
      return false
    }
  },
  created() {
    this.currentIndex = 4
  },
  mounted() {
    for (let i = 0; i < this.currentIndex; i++) {
      if (this.selectedOptions[i] === undefined || !this.selectedOptions[i].length) {
        this.$router.push({ path: '/step' + i + 1 })
      }
    }
    if (this.options[this.currentIndex].bg) {
      document.body.style.backgroundColor = this.options[this.currentIndex].bg
    } else {
      document.body.style.removeProperty('backgroundColor')
    }
    if (this.selectedOptions[this.currentIndex] !== undefined && this.selectedOptions[this.currentIndex].length) {
      this.showNext = true
    } else {
      this.showNext = false
    }
  }
}
</script>
